import React, { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../App.css';
import contactanos from '../img/Contactanos.jpg'; 

const Contactanos = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    mensaje: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'mensaje' && value.length > 500) return;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { nombre, telefono, mensaje } = formData;

    if (!nombre || !telefono || !mensaje) {
      setError('Todos los campos son obligatorios');
      setTimeout(() => {
        window.location.reload();
      }, 3000);
      return;
    }

    setError('');
    setSubmitted(false);

    try {
      const response = await fetch('https://fdi.com.co/enviar.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (!response.ok) throw new Error('Error al enviar el formulario');

      const data = await response.json();
      console.log(data.message);
      setSubmitted(true);
      setFormData({ nombre: '', telefono: '', mensaje: '' });

      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } catch (err) {
      console.error(err);
      setError('Hubo un problema al enviar tu mensaje. Intenta más tarde.');
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }
  };

  return (
    <div className="contact-container">
      <h2 className="contact-title">Contáctanos</h2>

      <div className="contact-content">
        {/* Formulario */}
        <div className="contact-form-wrapper">
          <div className="contact-form-box">
            <Form onSubmit={handleSubmit}>
              {error && (
                <Alert variant="danger" className="fade show">
                  <i className="bi bi-exclamation-triangle-fill me-2"></i>
                  {error}
                </Alert>
              )}

              {submitted && (
                <Alert variant="success" className="fade show">
                  <i className="bi bi-check-circle-fill me-2"></i>
                  ¡Gracias por contactarnos! Te responderemos pronto.
                </Alert>
              )}

              <Form.Group className="mb-3" controlId="formNombre">
                <Form.Label>Nombre</Form.Label>
                <Form.Control
                  type="text"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  placeholder="Ingresa tu nombre"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formTelefono">
                <Form.Label>Teléfono</Form.Label>
                <Form.Control
                  type="tel"
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleChange}
                  placeholder="Ingresa tu número de teléfono"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formMensaje">
                <Form.Label>Mensaje (máximo 500 caracteres)</Form.Label>
                <Form.Control
                  as="textarea"
                  name="mensaje"
                  value={formData.mensaje}
                  onChange={handleChange}
                  rows={5}
                  maxLength={500}
                  placeholder="Escribe tu mensaje"
                  required
                />
                <div className="text-end small">
                  {formData.mensaje.length}/500
                </div>
              </Form.Group>

              <div className="contact-button-wrapper">
                <Button variant="danger" type="submit" className="contact-button">
                  <i className="bi bi-send-fill me-2"></i> Enviar
                </Button>
              </div>
            </Form>
          </div>
        </div>

        {/* Imagen */}
        <div className="contact-image-wrapper">
          <img
            src={contactanos}
            alt="Contáctanos"
            className="contact-image"
          />
        </div>
      </div>
    </div>
  );
};

export default Contactanos;
